var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 42,
    height: 42,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GitHub icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .296C5.373.296 0 5.67 0 12.297c0 5.291 3.438 9.774 8.205 11.38.6.11.82-.26.82-.577v-2.16c-3.338.726-4.033-1.416-4.033-1.416-.546-1.386-1.333-1.756-1.333-1.756-1.089-.745.084-.73.084-.73 1.204.084 1.838 1.237 1.838 1.237 1.07 1.834 2.806 1.304 3.492.997.108-.774.418-1.305.76-1.606-2.665-.3-5.466-1.333-5.466-5.93 0-1.31.469-2.382 1.235-3.22-.123-.303-.535-1.52.117-3.166 0 0 1.007-.322 3.3 1.23a11.47 11.47 0 0 1 3.004-.403c1.02.004 2.046.138 3.003.403 2.292-1.552 3.297-1.23 3.297-1.23.653 1.646.241 2.863.118 3.166.769.838 1.235 1.91 1.235 3.22 0 4.61-2.807 5.625-5.478 5.92.43.371.814 1.102.814 2.222v3.293c0 .32.218.694.824.575C20.565 22.07 24 17.585 24 12.297 24 5.67 18.627.296 12 .296z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.b8e63d452c6783bfb735b9c0cd447e02.svg";
export { ForwardRef as ReactComponent };